import {
  stockAnalysisCategoryToSectionMapping
} from "../getSectionSlugBySectionId";
import { prepareSectionIdList } from "../prepareSectionsList";
import { isNativeStockPageStrategySection } from "./nativeStockPageStrategySections";

const SECTION_ID_TO_ANALYSIS_CATEGORY = Object.freeze(
  Object.entries(stockAnalysisCategoryToSectionMapping).reduce(
    (acc, [notificationsUniqueId, sectionId]) => {
      acc[sectionId] = notificationsUniqueId;
      return acc;
    },
    {}
  )
);

/**
 * Builds slug → section_id map from the SEO section list API payload.
 * @param {Array<{ section_id: string, slug: string }>|undefined|null} slugList
 */
export function buildSectionIdBySlugMap(slugList) {
  return prepareSectionIdList(slugList);
}

/**
 * Resolves a route param (section id or SEO slug) to the canonical section id
 * used by native stock section pages.
 *
 * @param {string} sectionParam
 * @param {{ sectionIdBySlug?: Record<string, string>, preparedSlugList?: Record<string, string> }} [options]
 * @returns {string|null}
 */
export function resolveStockPageSectionParam(sectionParam, options = {}) {
  if (!sectionParam || typeof sectionParam !== "string") {
    return null;
  }

  const { sectionIdBySlug, preparedSlugList } = options;

  let sectionIdBySlugMap = sectionIdBySlug;

  if (!sectionIdBySlugMap && preparedSlugList) {
    sectionIdBySlugMap = Object.entries(preparedSlugList).reduce(
      (acc, [sectionId, slug]) => {
        if (slug) {
          acc[slug] = sectionId;
        }
        return acc;
      },
      {}
    );
  }

  if (sectionIdBySlugMap && sectionIdBySlugMap[sectionParam]) {
    return sectionIdBySlugMap[sectionParam];
  }

  if (SECTION_ID_TO_ANALYSIS_CATEGORY[sectionParam]) {
    return SECTION_ID_TO_ANALYSIS_CATEGORY[sectionParam];
  }

  if (preparedSlugList && preparedSlugList[sectionParam]) {
    return sectionParam;
  }

  return sectionParam;
}

/**
 * True when the resolved section must not open as a native section page.
 */
export function shouldSkipNativeStockPageSection(sectionParam, options) {
  const resolved = resolveStockPageSectionParam(sectionParam, options);

  if (!resolved) {
    return true;
  }

  return isNativeStockPageStrategySection(resolved);
}
